// extracted by mini-css-extract-plugin
module.exports = {"box":"FlippingSquare_box__bEZSt","plane":"FlippingSquare_plane__3OKSK","flip":"FlippingSquare_flip__3s6Dw"};